const validInputRegexQuoteSizeLeg = /^$|^\d+(\.\d*)?(M{1,2}|m{1,2})?$/;
// Allows only numbers, dot (.), and 'm'/'M'

export const isValidInputQuoteSize = (input: string): boolean => {
  if (input.match(/m{3,}|M{3,}|(mM|Mm)/)) {
    return false; // return early if there are already 2 m (don't allow a third)
  }
  if (validInputRegexQuoteSizeLeg.test(input)) {
    return true;
  }
  return false;
};

// Final regex: Ensures numbers with max **one** `.` + ends in `mm` or `MM`
export const finalInputRegexQutoeSize = /^\d+(\.\d+)?(m{1,2}|M{1,2})?$/;

export const isFinalValidInputQuoteSize = (input: string): boolean => {
  return finalInputRegexQutoeSize.test(input); // ✅ Final stricter validation
};

export const returnQuoteSizeWithMConvertedToThousands = (
  input: string,
): number => {
  const numericPart = input.replace(/[mM]+$/, ""); // Remove 'm', 'M', etc.
  const mCount = (input.match(/[mM]/g) || []).length; // Count 'm' occurrences
  return parseFloat(numericPart) * Math.pow(1000, mCount);
};
